import { render, staticRenderFns } from "./subproperty-list-table.vue?vue&type=template&id=5537e332&"
import script from "./subproperty-list-table.vue?vue&type=script&lang=js&"
export * from "./subproperty-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports